import { createContext, useContext, useState } from 'react'

import { ReactCallBackFunction } from 'src/types/CallbackFunction'

type ModalState = 'rename' | 'delete' | null

interface PageHeaderDashboardMenuType {
  modalOpened: ModalState
  setModalOpened: ReactCallBackFunction<ModalState>
}

const PageHeaderDashboardMenuStoreContext = createContext<PageHeaderDashboardMenuType | null>(null)

export const PageHeaderDashboardMenuProvider = ({ children }) => {
  const [modalOpened, setModalOpened] = useState<PageHeaderDashboardMenuType['modalOpened']>(null)

  return (
    <PageHeaderDashboardMenuStoreContext.Provider value={{ modalOpened, setModalOpened }}>
      {children}
    </PageHeaderDashboardMenuStoreContext.Provider>
  )
}

export const usePageHeaderDashboardMenuContext = () => {
  const context = useContext(PageHeaderDashboardMenuStoreContext)
  if (!context) {
    throw new Error('Missing PageHeaderDashboardMenuStoreContext.Provider')
  }
  return context
}
